<template>
  <div class="nav_menu">
    <el-menu :default-active="$route.path" class="menus" mode="horizontal" background-color="#fff" text-color="#1c2726" active-text-color="#f00" router>
      <el-menu-item index="/">首页</el-menu-item>
      <el-menu-item index="/introduce">公司介绍</el-menu-item>
      <el-menu-item index="/service">产品与服务</el-menu-item>
      <el-menu-item index="/about">关于我们</el-menu-item>
      <el-menu-item index="/cooperation">业务合作</el-menu-item>
    </el-menu>
    <div class="logo"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "/",
    }
  },
  created() {},
  methods: {},
}
</script>

<style scoped lang="less">
.nav_menu {
  position: relative;
  .menus {
    display: flex;
    justify-content: center;
  }
  .is-active {
    color: #fff !important;
    border-color: transparent !important;
    background: #0861cc !important;
  }

  .logo {
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    height: 61px;
    padding: 10px;
    background: url("../assets/logo.png") no-repeat;
    background-size: contain;
    background-position: 100% 100%;
  }
}
</style>
